module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/invoices/invoice-view/invoice-view.scss
// module id = ./web/modern/components/invoices/invoice-view/invoice-view.scss
// module chunks = 0